export const CalendarCheck = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 27H6C5.44772 27 5 26.5523 5 26V6C5 5.44772 5.44772 5 6 5H26C26.5523 5 27 5.44772 27 6V12" stroke="currentColor" stroke-width="2"/>
<path d="M21 8V2" stroke="currentColor" stroke-width="2"/>
<path d="M11 8V2" stroke="currentColor" stroke-width="2"/>
<circle cx="21" cy="22" r="7" stroke="currentColor" stroke-width="2"/>
<path d="M17.5 21.9031L19.8928 24.29L24.5 19.71" stroke="currentColor" stroke-width="2"/>
</svg>`;
